import { render, staticRenderFns } from "./IsLoading.vue?vue&type=template&id=188eacfa&scoped=true&"
import script from "./IsLoading.vue?vue&type=script&lang=js&"
export * from "./IsLoading.vue?vue&type=script&lang=js&"
import style0 from "./IsLoading.vue?vue&type=style&index=0&id=188eacfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188eacfa",
  null
  
)

export default component.exports